// Получаем базовый хост
const host =
  document.location.hostname === 'localhost' || document.location.hostname === '127.0.0.1'
    ? process.env.REACT_APP_API_HOST || window.location.origin
    : window.location.origin;

export const api = {
  host,
  initPath: `${host}/site/api/init`,
  templatesPath: `${host}/site/api/templates`,
  iconsPath: `${host}/site/api/icons`,
};
